import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ScreenSizeContext } from '@wix/da-hooks/pkg/useMeasureElement/ScreenSizeContext';
import mapValues from 'lodash/mapValues';
import omit from 'lodash/omit';
import isArray from 'lodash/isArray';
import { WindowBreakpoint } from './types';
/**
 *
 */ export function useElementPlacementForArea(placementArea, context) {
    const elementPlacementMap = useContext(context);
    const mapWithBooleansInstead = mapValues(omit(elementPlacementMap, [
        'elementGroups',
        'meta'
    ]), (placement)=>{
        return isArray(placement) ? placement.includes(placementArea) : placement === placementArea;
    });
    return _object_spread_props(_object_spread({}, mapWithBooleansInstead), {
        elementGroups: mapValues(elementPlacementMap.elementGroups, (elementGroup)=>_object_spread_props(_object_spread({}, elementGroup), {
                groupPlacement: elementGroup.groupPlacement === placementArea
            })),
        meta: elementPlacementMap.meta
    });
}
// TODO: Expand with other common breakpoints
export function useWindowBreakpoint() {
    const isMobile = useContext(MobileContext);
    const screenSize = useContext(ScreenSizeContext);
    if (isMobile) {
        return WindowBreakpoint.MobileAverageSize;
    }
    if (screenSize.width >= 1100) {
        return WindowBreakpoint.DesktopAverageSize;
    }
    return WindowBreakpoint.DesktopSmallSize;
}

//# sourceMappingURL=utils.js.map